module.exports = __webpack_public_path__ + "img/rec-03.56aed53d.png";